import { StyledFilterChip, StyledFilterLabel } from './styled';
import { RotateCcw } from 'lucide-react';

const FilterBadge = ({ data, label, currentValue, disableOpen, disableDelete, isOpen, onClick, onClickX, id = '' }) => {
  return (
    <>
      {!data && !isOpen && (
        <StyledFilterLabel>
          {label}
          <button data-cy={`${id}-filter`} onClick={onClick}>
            <span>Adicionar filtro</span>
          </button>
        </StyledFilterLabel>
      )}

      {data && open && (
        <StyledFilterChip data-cy={`${id}-chip`} disableOpen={disableOpen}>
          {/* eslint-disable-next-line*/}
          <span onClick={disableOpen ? null : onClick}>{currentValue}</span>

          {disableDelete ? (
            <RotateCcw size={10} strokeWidth={3} />
          ) : (
            <button type="button" onClick={onClickX}>
              <span>Remover filtro</span>
            </button>
          )}
        </StyledFilterChip>
      )}
    </>
  );
};

export { FilterBadge };
